'use client';

import { FC, PropsWithChildren } from 'react';

import { getRoute } from '@ravago/shared/next-data-access';
import { DynamicPageUrl } from '@ravago/shared/page-data/models/utils';

import { useConfigContext } from '../../../hooks/use-config-context';
import { Link } from '../../shared/link/link';

interface DynamicPageLinkProps extends PropsWithChildren {
   anchor?: string;
   id: string;
   baseRoute: DynamicPageUrl | null;
   locale: string;
   prefetch?: boolean;
   slug?: string;
   underline?: 'none' | 'hover' | 'always';
   height?: string;
   target?: string;
}

export const DynamicPageLink: FC<DynamicPageLinkProps> = ({
   baseRoute,
   id,
   locale,
   slug,
   anchor,
   prefetch = false,
   underline = 'always',
   height,
   target,
   children
}) => {
   const { useLegacyDigitalPlatformRoutes } = useConfigContext();

   const href = baseRoute?.url ? getRoute(locale, baseRoute.url, slug, anchor, useLegacyDigitalPlatformRoutes) : '';

   return (
      <Link
         id={id}
         noFollow={baseRoute?.noFollow}
         href={href}
         underline={underline}
         prefetch={prefetch}
         target={target}
         style={{ height }}
         data-testid="dynamic-page-link__link"
      >
         {children}
      </Link>
   );
};
